import { Badge, Box, Group, Text, Title } from "@mantine/core";
import { generateColors } from "@mantine/colors-generator";
import { Palette } from "@phosphor-icons/react";

interface Props {
  primaryColor: string;
}

function contrastingText(hex: string): string {
  const h = hex.replace("#", "");
  if (h.length !== 6) return "#FFFFFF";
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
  return luminance > 160 ? "#0F172A" : "#FFFFFF";
}

export function PaletteTuple({ primaryColor }: Props) {
  let palette: string[] = [];
  try {
    palette = generateColors(primaryColor) as unknown as string[];
  } catch {
    palette = Array(10).fill(primaryColor);
  }

  return (
    <Box>
      <Group gap="sm" mb="sm" align="center">
        <Box
          style={{
            width: 28,
            height: 28,
            borderRadius: 8,
            background: "color-mix(in oklch, var(--mantine-color-brand-6) 14%, transparent)",
            color: "var(--mantine-color-brand-6)",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Palette size={16} />
        </Box>
        <Title order={5}>Гарсан палитр</Title>
        <Badge size="xs" color="brand">
          10 алхам
        </Badge>
      </Group>
      <Text size="xs" c="dimmed" mb="sm">
        Mantine v9 <Box component="span" style={{ fontFamily: "ui-monospace, monospace" }}>theme.colors.brand[0..9]</Box>
      </Text>
      <Box style={{ display: "grid", gridTemplateColumns: "repeat(10, 1fr)", gap: 4 }}>
        {palette.map((hex, i) => (
          <Box
            key={i}
            title={`brand[${i}] · ${hex}`}
            style={{
              position: "relative",
              aspectRatio: "1 / 1.4",
              borderRadius: 6,
              background: hex,
              border: i === 6 ? "2px solid var(--mantine-color-dark-9)" : "1px solid var(--mantine-color-gray-2)",
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "center",
              padding: 4,
            }}
          >
            <Box
              component="span"
              style={{
                fontSize: 10,
                fontWeight: 600,
                fontFamily: "ui-monospace, monospace",
                color: contrastingText(hex),
                opacity: 0.85,
              }}
            >
              {i}
            </Box>
          </Box>
        ))}
      </Box>
      <Group gap="xs" mt="sm">
        <Badge size="xs" color="gray" variant="light">
          [6] solid
        </Badge>
        <Text size="xs" c="dimmed">
          — үндсэн товч, badge, link
        </Text>
      </Group>
    </Box>
  );
}
